import React from "react";
import { fallbackBlogs } from "./fallbackBlogsData";
import BlogContentRenderer from "./BlogContentRenderer";

/**
 * StaticBlogContent — Admin blogs ke liye static content
 * fallbackBlogs ka fb-1 (WordPress Development) ka EXACT same content use karta hai.
 * Yeh content hamesha same rahega har admin-added blog ke liye.
 */
const StaticBlogContent = () => {
  // fb-1 ka exact content use karo — wahi jo images mein dikh raha tha
  const staticContent = fallbackBlogs[0]?.content || "";

  return <BlogContentRenderer content={staticContent} />;
};

export default StaticBlogContent;
